/* eslint-disable no-unused-vars */
import '~/sass/pages/showroom360.scss';
import CI360 from 'js-cloudimage-360-view/dist/ci360.service';
import Interior360 from '@/libs/showcase-vr/interior-360';

const { $ } = window;

const external360Id = 'external360';
let initWindowWidth = $(window).width();

$(document).ready(() => {
  const pathArr = /\/showroom\/([^/]+)\//.exec(window.location.pathname);
  const carname = (pathArr && pathArr.length > 1) ? pathArr[1] : 'toyota';
  let external360 = null;

  if (initWindowWidth < 1024) {
    $('#external360').attr('data-folder', '/Bz/public/mock/showroom360/Gray/mobile/');
  } else {
    $('#external360').attr('data-folder', '/Bz/public/mock/showroom360/Gray/');
  }

  function initExternal360() {
    external360 = new CI360(document.getElementById(external360Id));
  }

  function destroyExternal360() {
    if (external360) {
      external360.destroy();
      external360 = null;
    }
  }

  function reInitExternal360() {
    destroyExternal360();
    initExternal360();
  }

  function initHeight360() {
    $('.nav-link#interiorWith360-tab').on('click', () => {
      const height360 = $('#externalWith360').height();
      console.log(height360);
      $('.interior-360 .roll360').css('height', height360);
    });
  }

  function setupVideo() {
    const video = document.getElementById('video-360');
    video.addEventListener('ended', () => {
      video.style.display = 'none';
      $('#external360').addClass('show');
    });
  }

  $('.js-360-switch-color').on('click', (event) => {
    event.preventDefault();
    initWindowWidth = $(window).width();
    const target = $(event.currentTarget);
    const targetFolder = target.data('folder');
    const targetFilename = target.data('filename');
    const targetColorname = target.data('colorname');

    const canvas = $('.cloudimage-360');
    const colorName = $('.color-name');
    if (initWindowWidth < 1024) {
      canvas.attr('data-folder', `${targetFolder}/mobile/`);
    } else {
      canvas.attr('data-folder', targetFolder);
    }
    canvas.attr('data-filename', targetFilename);
    colorName.text(targetColorname);

    $('.js-360-switch-color').removeClass('active');
    target.addClass('active');
    reInitExternal360();
  });

  if ($('#interiorWith360 .roll360').length > 0) {
    $('#interiorWith360 .roll360').each((i, e) => {
      // eslint-disable-next-line no-new
      new Interior360($(e), carname);
    });
  }

  $(window).on('resize', () => {
    initWindowWidth = $(window).width();
    if (external360) {
      external360.update();
    }
    // if (initWindowWidth < 1024) {
    //   $('#belt .arrow').css('display', '');
    // }
    setTimeout(() => {
      initHeight360();
    }, 2000);
  });

  initExternal360();
  setupVideo();
});
